class WFooter extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.form = this.querySelector('.w-footer__form');
    if (!this.form) return;

    const { signal } = this.controller;
    this.form.addEventListener(
      'submit',
      () => {
        this.form.classList.add('is-loading');
        const button = this.form.querySelector('.w-footer__submit');
        if (button) button.setAttribute('aria-busy', 'true');
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

customElements.define('w-footer', WFooter);
